module.exports = __webpack_public_path__ + "static/System@2x-e8a453c039659fc12897e54dd851574d.jpg";